import Head from 'next/head';
import Link from 'next/link';
import { useRouter } from 'next/router';

import BlockedUserModal from '@zg-rentals/blocked-user-modal';

import type { User } from '../../AuthProvider';
import { AppLayoutContainer } from '@zg-rentals/zrm-header-navigation';
import { StyledContainer } from '@zg-rentals/zrs-comet';

import StringConstants from '../../constants/StringConstants';

export default function Layout({ children, user }: React.PropsWithChildren<{ user: User }>) {
  const hostName = typeof window !== 'undefined' && window !== null ? window.location.host : 'www.zillow.com';
  const router = useRouter();
  const pathname = `${router.basePath}${router.pathname}`;

  const { isRocketshipCustomerOnly, restrictions } = user;
  const showBlockedUserModal = restrictions?.isAllowed === false;

  return (
    <div id="app-root">
      <Head>
        <title>{StringConstants.PAYMENTS_PAGE}</title>
      </Head>
      {showBlockedUserModal && <BlockedUserModal user={user} />}
      <StyledContainer id="App">
        <AppLayoutContainer
          useLeftNav={true}
          altLogo={!isRocketshipCustomerOnly}
          brand={StringConstants.UNFORMATTED_BRAND_NAMES.zillow}
          userModel={user}
          useRelativePaths={false}
          reactRouterLink={Link}
          host={hostName}
          pathname={pathname}
          displayMainMyProperties={true}
        >
          <main>{children}</main>
        </AppLayoutContainer>
      </StyledContainer>
    </div>
  );
}
